"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalUserRegistrationDto = void 0;
const external_user_registration_status_enum_1 = require("./external-user-registration-status.enum");
class ExternalUserRegistrationDto {
    constructor() {
        this.id = '';
        this.userId = '';
        this.givenName = '';
        this.lastName = '';
        this.city = '';
        this.country = '';
        this.company = '';
        this.email = '';
        this.approverEmail = '';
        this.requesterEmail = '';
        this.createdAt = new Date(0);
        this.status = external_user_registration_status_enum_1.ExternalUserRegistrationStatus.pending;
        this.approvals = [];
        this.requesterFullName = '';
    }
}
exports.ExternalUserRegistrationDto = ExternalUserRegistrationDto;
//# sourceMappingURL=external-user-registration.dto.js.map